const ITEMS = ["CONSTRUCȚII", "RENOVĂRI & INTERIOARE", "INSTALAȚII", "EXTERIOR", "ENERGIE", "LUCRĂRI SPECIALE"];

function Row({ hidden = false }) {
  return (
    <div aria-hidden={hidden} className="flex w-max shrink-0 items-center">
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span className="display-title px-6 text-2xl sm:px-10 sm:text-4xl text-paper/85">{item}</span>
          <span className="block h-2.5 w-2.5 rotate-45 bg-copper" aria-hidden="true" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <section className="overflow-hidden border-y border-white/10 bg-ink-900 py-4 sm:py-6" data-testid="services-marquee">
      <div className="flex w-max animate-marquee">
        <Row />
        <Row hidden />
      </div>
    </section>
  );
}
